import * as React from "react";
import { useAuthProvider } from "../middleware/AuthProvider";
import { AuthContext } from "src/components/context/AuthContext";

export const SecureProvider: React.SFC = props => {
  const authProvider = useAuthProvider();
  return <AuthContext.Provider value={authProvider}>{props.children}</AuthContext.Provider>;
};



// WEBPACK FOOTER //
// ./src/services/provider/Secure.provider.tsx